// import { PayloadAction } from '@reduxjs/toolkit'
import { produce } from 'immer';

// TYPES
import { UserData } from '@/types/auth';

// UTILITY
import store from '@/utility/store';
import { checkIsAdmin } from '@/utility/roles';

import {
  login,
  loginWithAuth0,
  registerUser,
  createPassword,
  resetPasswordSendEmail,
  resetPassUpdate,
  logout,
  setAnonymousId,
  loginAs,
} from '../actions/auth';
import { updateSettingsDictionary } from '../actions/settings';

const token = store.get('token') || '';
const adminToken = store.get('admin_token') || '';
const anonymousId = store.get('ajs_anonymous_id');

// interface PartnerData {
//   settings: {
//     reporting_logo_overwrite: string;
//   };
//   logo: string;
// }

interface AuthState {
  user: UserData | null;
  anonymousId: string;
  partner: any; // TODO Add partner type
  isAuth: boolean;
  isAdmin: boolean;
  hasAdminToken: boolean;
  loading: boolean;
  loginAsLoading: boolean;
}

interface AuthAction {
  type: string;
  payload: any; // TODO Describe payload type
}

const initialState: AuthState = {
  user: null,
  anonymousId: anonymousId || '',
  partner: {},
  isAuth: !!token,
  isAdmin: false,
  hasAdminToken: !!adminToken,
  loading: false,
  loginAsLoading: false,
};

const reducer = produce((state: AuthState = initialState, action: AuthAction): AuthState => {
  switch (action.type) {
    // LOGIN
    case login.types.START:
    case loginWithAuth0.types.START:
    case createPassword.types.START:
    case resetPassUpdate.types.START:
      state.loading = true;
      return state;
    case login.types.SUCCESS:
    case loginWithAuth0.types.SUCCESS:
    case createPassword.types.SUCCESS:
    case resetPassUpdate.types.SUCCESS:
      state.loading = false;
      state.isAuth = true;
      state.isAdmin = checkIsAdmin(action.payload.user);
      state.user = action.payload.user;
      state.partner = action.payload.partner;
      return state;
    case login.types.FAIL:
    case loginWithAuth0.types.FAIL:
    case createPassword.types.FAIL:
    case resetPassUpdate.types.FAIL:
      state.loading = false;
      state.isAuth = false;
      return state;

    // LOGIN AS
    case loginAs.types.START:
      state.loginAsLoading = true;
      return state;
    case loginAs.types.FAIL:
      state.loginAsLoading = false;
      return state;

    // REGISTER
    case registerUser.types.START:
      state.loading = true;
      return state;
    case registerUser.types.SUCCESS:
      state.loading = false;
      state.isAuth = true;
      state.isAdmin = checkIsAdmin(action.payload.user);
      state.user = action.payload.user;
      return state;
    case registerUser.types.FAIL:
      state.loading = false;
      state.isAuth = false;
      return state;

    // RESET PASSWORD SEND EMAIL
    case resetPasswordSendEmail.types.START:
      state.loading = true;
      return state;
    case resetPasswordSendEmail.types.SUCCESS:
      state.loading = false;
      return state;
    case resetPasswordSendEmail.types.FAIL:
      state.loading = false;
      return state;

    // LOGOUT
    case logout.types.INIT:
      state.isAuth = false;
      state.isAdmin = false;
      state.user = null;
      state.partner = {};
      return state;

    // SET ANONYMOUS ID
    case setAnonymousId.types.INIT:
      state.anonymousId = action.payload.id;
      return state;

    // UPDATE PARTNER
    case updateSettingsDictionary.types.SUCCESS:
      state.partner = action.payload.partner;
      return state;

    default:
      return state;
  }
});

export default reducer;
